import { slideDown, slideUp } from './slideToggle';

const basis = document.querySelectorAll('.js-toggle-form');
if (basis) {
  basis.forEach((base) => {
    base.addEventListener('change', () => {
      if ((base as HTMLInputElement).type == "checkbox") {
        if((base as HTMLInputElement).checked) {
          ToggleForm(base as HTMLInputElement);
        } else {
          const baseClass: string = (base as HTMLElement).dataset.target!;
          CloseToggle(baseClass);
        }
      } else {
        ToggleForm(base as HTMLElement);
      }
    });

    window.addEventListener('load', () => {
      if ((base as HTMLInputElement)&&(base as HTMLInputElement).checked) {
        ToggleForm(base as HTMLElement);
      }
    });
  });
}

const ToggleForm = async(base: HTMLElement) => {
  const baseClass: string = base.dataset.target!;
  await CloseToggle(baseClass);
  if ((base as HTMLElement).dataset.target) {
    const target = document.querySelector<HTMLElement>(
      `${(base as HTMLElement).dataset.target}`
    );

    if (target) {
      if (!(target as HTMLElement).classList.contains("slide-toggle-open") ) {
        setTimeout(()=>{
          slideDown(target);
        }, 300);
        (target as HTMLElement).classList.add('slide-toggle-open');
      }
    }
  }
};

const CloseToggle = (baseClass: string):Promise<boolean> => {
  return new Promise((resolve) => {
    setTimeout(()=>{
    const targets = document.querySelector(`${baseClass}`) as HTMLElement;
    if (targets) {
      slideUp(targets);
      targets.classList.remove("slide-toggle-open");
    }
    resolve(true);
    }, 100);
  })
}
